import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import LandingPageForms from '../../components/LandingPage/LandingPageForms/LandingPageForms';
import LandingPageMoreTransactions from '../../components/LandingPage/LandingPageMoreTransactions/LandingPageMoreTransactions';
import LandingPageSection from '../../components/LandingPage/LandingPageSection/LandingPageSection';
import AppTitle from '../../components/Shared/AppTitle/AppTitle';
import CollegeBrandingContainer from '../../components/Shared/CollegeBrandingContainer/CollegeBrandingContainer';
import FullPageLoader from '../../components/Shared/FullPageLoader/FullPageLoader';
import StepsPageBackground from '../../components/Shared/StepsPageBackground/StepsPageBackground';
import TRP from '../../components/Shared/TRP/TRP';
import config from '../../config/config';
import { moduleActions } from '../../redux/modules';
import { getHasPendingTransactions } from '../../redux/modules/pendingTransactions/pendingTransactions.selectors';
import {
  getHasCollegeOnly,
  getHasMixedCollegeTypes,
  getProductTypes,
} from '../../redux/modules/productTypes/productType.selectors';
import { getIsRMDEligibleMF } from '../../redux/modules/transactionLanding/transactionLanding.selectors';
import {
  analyticsDataLayer,
  dispatchPageLoad,
} from '../../redux/utils/analytics-helper';
import { APP_FAILURE, ProductTypes } from '../../settings/settings';
import './TransactionLandingPage.scss';
import transactionLandingPageContent, {
  rmdTile,
} from './TransactionLandingPageContent';
import {
  getIsMobileParam,
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../redux/modules/authentication/authentication.module.selectors';
import RASText from '../../components/Shared/RASText/RASText';
import APPText from '../../components/Shared/APPText/APPText';
import { getUserAge } from '../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import { getTraditionalOrRolloverIraFunds } from '../../redux/modules/funds/UserFunds/userFunds.selectors';
import { isRolloverOrTraditionalIRA } from '../../utils/funds/shared/shared-fund-notes-utility';
import { getApplicationStatus } from '../../redux/modules/applicationData/applicationData.selectors';

export class TransactionLandingPage extends Component {
  componentDidMount() {
    const {
      actions: { loadApplication, setAppLoading },
    } = this.props;
    dispatchPageLoad('Transaction Landing');
    setAppLoading();
    analyticsDataLayer();
    loadApplication(this.props.actions);
  }

  render() {
    const {
      isSalesforceRep,
      customerWebViewEnabled,
      applicationData: { hasFailed, isLoading },
      hasCollegeOnly,
      hasMixedCollegeTypes,
      hasPendingTransactions,
      isRMDEligibleMF,
      isTraditionalOrRolloverIraFunds,
      userProductTypes: {
        hasAK529,
        hasAPP,
        hasBrokerage,
        hasMD529,
        hasMutualFund,
        hasNAT529,
        hasRAS,
      },
      age,
    } = this.props;
    const hasCollege = hasAK529 || hasMD529 || hasNAT529;
    const isRolloverOrTraditionalIRAFund = isTraditionalOrRolloverIraFunds.some(
      (fund) => isRolloverOrTraditionalIRA(fund)
    );
    const message = '';
    const getError = () => {
      if (hasFailed) {
        return {
          type: APP_FAILURE,
          hasError: true,
        };
      }
      return {
        type: '',
        hasError: false,
      };
    };
    return (
      <div className="transaction-landing-page">
        <CollegeBrandingContainer>
          <FullPageLoader
            errorType={getError().type}
            hasError={getError().hasError}
            isVisible={isLoading}
            messages={message}
          />
          <StepsPageBackground size="small" />
          <div className="transaction-landing-page-container container">
            <AppTitle title="Transactions" />
          </div>
          <a
            className="container e2e-transactions-link college-branded-link transaction-landing-page-view-transactions-link"
            href={`${config.url}/usis/my-accounts/transactions`}
          >
            View {hasPendingTransactions ? 'Pending' : 'Transaction'} Activity
          </a>
          {/* Advisory Sections:
           * Only up to one of the next three blocks can show up for any given user:
           * -APP client
           * -RAS client
           * -Advisory client (i.e. client with both APP and RAS)
           */}
          {!hasRAS && hasAPP && (
            <LandingPageSection
              content={[
                ...transactionLandingPageContent[ProductTypes.ACTIVEPLUS],
              ]}
              description={
                <>
                  Transact within your <APPText plural /> account(s).
                </>
              }
              title="ActivePlus Portfolios®"
            />
          )}
          {hasRAS && !hasAPP && (
            <LandingPageSection
              content={transactionLandingPageContent[ProductTypes.RAS]}
              description={
                <>
                  Transact within your <RASText /> account(s).
                </>
              }
              title="Retirement Advisory Service™"
            />
          )}
          {hasRAS && hasAPP && (
            <LandingPageSection
              content={[
                ...transactionLandingPageContent[
                  ProductTypes.RAS + ProductTypes.ACTIVEPLUS
                ],
              ]}
              description={
                <span>
                  Transact within your advisory products; <RASText tradeMark />{' '}
                  and <APPText registeredTradeMark plural /> accounts.
                </span>
              }
              title="Advisory Accounts"
            />
          )}
          {hasMutualFund && (
            <LandingPageSection
              content={[
                ...transactionLandingPageContent[ProductTypes.MUTUALFUND],
                ...(isRMDEligibleMF ? [rmdTile] : []),
              ]}
              description="Add, withdraw, or move money to an existing fund or new fund. You can also add or edit an automatic transaction."
              title="Mutual Funds"
            />
          )}
          {hasBrokerage && (
            <LandingPageSection
              content={transactionLandingPageContent[ProductTypes.BROKERAGE]}
              description="Manage your stocks, ETFs, and mutual funds in your Brokerage accounts."
              descriptionNotes={
                <span>
                  {!(!customerWebViewEnabled && isSalesforceRep) && (
                    <span>
                      <br></br>
                      <p className="note">
                        To trade on fixed income securities, including corporate
                        and government bonds and CDs, please{' '}
                        <a
                          href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                          target="_blank"
                          rel="noreferrer"
                          className="contact-link"
                        >
                          contact us
                        </a>
                        .
                      </p>
                    </span>
                  )}
                </span>
              }
              title="Brokerage"
            />
          )}
          {hasCollege && (
            <LandingPageSection
              content={transactionLandingPageContent['COLLEGE']}
              description="Manage your 529 Plans."
              title="529 Plans"
            />
          )}
          <div className="clear" />
          <LandingPageMoreTransactions
            collegeTypes={{ hasAK529, hasMD529, hasNAT529 }}
            hasBrokerage={hasBrokerage}
            hasCollegeOnly={hasCollegeOnly}
            hasMixedCollegeTypes={hasMixedCollegeTypes}
            age={age}
            isRolloverOrTraditionalIRAFund={isRolloverOrTraditionalIRAFund}
          />
          <LandingPageForms />
          {hasBrokerage && (
            <div className="transaction-landing-page-disclaimer">
              <p className="container">
                ¹Option trading involves additional risk and is not suitable for
                all investors. Subject to the approval of <TRP /> Brokerage.
              </p>
            </div>
          )}
          <div className="white-background">
            <p className="container">2820052</p>
          </div>
        </CollegeBrandingContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    applicationData: getApplicationStatus(state),
    hasCollegeOnly: getHasCollegeOnly(state),
    hasMixedCollegeTypes: getHasMixedCollegeTypes(state),
    hasPendingTransactions: getHasPendingTransactions(state),
    isRMDEligibleMF: getIsRMDEligibleMF(state),
    userProductTypes: getProductTypes(state),
    isMobileParam: getIsMobileParam(state),
    age: getUserAge(state),
    isTraditionalOrRolloverIraFunds: getTraditionalOrRolloverIraFunds(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
  dispatch,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  TransactionLandingPage
);
